import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { TradePlanData } from '../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../classes/tradePlan/tradePlanProvider';
import { colors } from '../../../../../../../colorVars';
import { Body4 } from '../../../../../../atomic/text/Text';

type Props = {
  date: string;
  type: string;
};

export const SelectOptionModalHeader = observer(({ date, type }: Props) => {
  const tradePlanForm: TradePlanData = useTradePlanFormStore();
  const optionManagement = tradePlanForm.optionManagement;

  const [allChecked, setAllChecked] = useState(false);
  return (
    <thead>
      <tr>
        <th
          colSpan={8}
          style={{
            borderBottom: '1px solid rgb(88, 88, 88)',
            borderTop: '1px solid rgb(88, 88, 88)',
          }}
        >
          <Body4 color={colors.lightGrey}>{date}</Body4>
        </th>
      </tr>
      <tr>
        <th>
          <div>
            <input
              type="checkbox"
              checked={allChecked}
              onChange={({ target }) => {
                optionManagement.setAllSymbolsOfDate(
                  date,
                  target.checked,
                  type
                );
                setAllChecked(target.checked);
              }}
            />
          </div>
        </th>
        <th>
          <Body4 color={colors.lightGrey}>Strike</Body4>
        </th>
        <th>
          <Body4 color={colors.lightGrey}>Bid</Body4>
        </th>
        <th>
          <Body4 color={colors.lightGrey}>Ask</Body4>
        </th>
        <th>
          <Body4 color={colors.lightGrey}>Delta</Body4>
        </th>
        <th>
          <Body4 color={colors.lightGrey}>Theta</Body4>
        </th>
        <th>
          <Body4 color={colors.lightGrey}>Open Interest</Body4>
        </th>
        <th>
          <Body4 color={colors.lightGrey}>Volume</Body4>
        </th>
      </tr>
    </thead>
  );
});
